/**
 * Floating suggestion lists for camera overlay.
 * Used by the FloatingSuggestions system in Camera.
 */

export const glowSuggestions = [
	"Give a compliment to another person",
	"Teach someone a special skill free of charge",
	"Organize a food drive",
	"Help a neighbor with their groceries",
	"Volunteer at a local charity",
	"Write a thank you note to someone special",
	"Pay for someone's coffee behind you",
	"Mentor someone in your field",
	"Clean up a public space",
	"Call an old friend you haven't talked to in a while",
	"Leave a kind note for a coworker",
	"Donate clothes you no longer wear",
	"Hold the door open with a smile",
	"Share your umbrella with someone in the rain",
	"Bring treats to your local fire station",
	"Water a neighbor's plants while they're away",
	"Send a care package to someone far away",
	"Give someone a ride who needs it",
	"Babysit for free for a stressed parent",
	"Teach an elderly person how to use technology",
	"Leave a generous tip for great service",
	"Pick up litter you see on your walk",
	"Donate blood at a local blood bank",
	"Compliment someone's work publicly",
	"Share your skills at a community center",
	"Surprise someone with their favorite treat",
	"Help someone carry heavy items",
	"Write a positive review for a small business",
	"Offer to walk a neighbor's dog",
	"Send flowers to someone who needs cheering up",
	"Return shopping carts in the parking lot",
	"Give up your seat on public transportation",
	"Invite someone new to join your plans",
	"Make a meal for someone who is struggling",
	"Leave coins at a laundromat for others to use",
	"Recommend a friend for a job opportunity",
	"Share useful information you've learned",
	"Plant a tree in your community",
	"Pay someone's toll on the highway",
	"Offer to help someone move",
];

export const gratefulSuggestions = [
	"Who are you grateful for?",
	"What are you grateful for?",
	"What made you smile today?",
	"Who inspires you?",
	"What blessing are you thankful for?",
	"What moment brought you joy?",
	"Who has helped you recently?",
	"What do you appreciate about your life?",
];
